import "../manage.css";
import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const ManageUsers = () => {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);

        const token = localStorage.getItem("token");

        const response = await axios.get(
          "https://api.arkiva.gov.al/api/users",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        setUsers(response.data);
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const addUser = () => {
    navigate("/manage/users/add-new");
  };

  const editUser = (user) => {
    navigate(`/manage/users/${user._id}`);
  };

  const deleteUser = async (user) => {
    const confirmDelete = window.confirm(
      `Jeni i sigurt që dëshironi të fshini përdoruesin "${user.firstName} ${user.lastName}"?`,
    );

    if (!confirmDelete) return;

    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      await axios.delete(
        `https://api.arkiva.gov.al/api/users/delete/${user._id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setUsers((prevUsers) =>
        prevUsers.filter((item) => item._id !== user._id),
      );
    } catch (error) {
      console.error("Error deleting user:", error);

      alert(
        error.response?.data?.message ||
          "Ndodhi një gabim gjatë fshirjes së përdoruesit.",
      );
    } finally {
      setLoading(false);
    }
  };

  const filteredUsers = users.filter((user) => {
    const fullName = `${user.firstName} ${user.lastName}`.toLowerCase();

    const email = user.email?.toLowerCase() || "";

    return (
      fullName.includes(search.toLowerCase()) ||
      email.includes(search.toLowerCase())
    );
  });

  return (
    <div className="manage-page">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

      <div className="manage-page-header">
        <div className="manage-page-header-actions">
          <input
            type="text"
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <button onClick={addUser}>
            <i className="fa-solid fa-plus"></i> Shto Përdorues
          </button>
        </div>
      </div>

      <div className="manage-table">
        <table className="table">
          <thead>
            <tr>
              <th>Emri</th>
              <th>Email</th>
              <th>Telefon</th>
              <th>Roli</th>
              <th>Veprime</th>
            </tr>
          </thead>

          <tbody>
            {filteredUsers.length > 0 ? (
              filteredUsers.map((user) => (
                <tr key={user._id}>
                  <td data-label="Emri">
                    {user.firstName} {user.lastName}
                  </td>

                  <td data-label="Email">{user.email}</td>

                  <td data-label="Telefon">{user.phone}</td>

                  <td data-label="Roli">{user.role?.name || "Pa rol"}</td>

                  <td className="actions" data-label="Veprime">
                    <button onClick={() => editUser(user)}>
                      <i className="fa-solid fa-pen-to-square"></i>
                    </button>

                    <button onClick={() => deleteUser(user)}>
                      <i className="fa-solid fa-trash"></i>
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">Nuk u gjetën përdorues!</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ManageUsers;
